/**
 * Used for small gaps, such as the space between vertically stacked text strings.
 *
 * Reference value in default theme: `2px`
 */
export const spaceNarrowXsmall = 'var(--cb-space-narrow-xsmall)';

/**
 * Used for small gaps, such as the space between vertically stacked text strings.
 *
 * Reference value in default theme: `4px`
 */
export const spaceNarrowSmall = 'var(--cb-space-narrow-small)';

/**
 * Used for small gaps, such as the space between vertically stacked text strings.
 *
 * Reference value in default theme: `6px`
 */
export const spaceNarrowMedium = 'var(--cb-space-narrow-medium)';

/**
 * Used to apply space between vertically stacked text strings and elements within cards and list row.
 *
 * Reference value in default theme: `8px`
 */
export const spaceRegularMedium = 'var(--cb-space-regular-medium)';

/**
 * Used to apply space between elements within cards or list rows.
 *
 * Reference value in default theme: `12px`
 */
export const spaceRegularLarge = 'var(--cb-space-regular-large)';

/**
 * Used to apply space between elements within cards or list rows.
 *
 * Reference value in default theme: `16px`
 */
export const spaceRegularXlarge = 'var(--cb-space-regular-xlarge)';

/**
 * Used to apply space between elements within cards or list rows.
 *
 * Reference value in default theme: `20px`
 */
export const spaceRegularXxlarge = 'var(--cb-space-regular-xxlarge)';

/**
 * Used to apply space between elements within cards or list rows.
 *
 * Reference value in default theme: `24px`
 */
export const spaceRegularXxxlarge = 'var(--cb-space-regular-xxxlarge)';

/**
 * Broad spacing
 *
 * Reference value in default theme: `28px`
 */
export const spaceBroadMedium = 'var(--cb-space-broad-medium)';

/**
 * Used to apply space between elements within cards or list rows.
 *
 * Reference value in default theme: `32px`
 */
export const spaceBroadLarge = 'var(--cb-space-broad-large)';

/**
 * Used to apply space between elements within cards or list rows.
 *
 * Reference value in default theme: `36px`
 */
export const spaceBroadXlarge = 'var(--cb-space-broad-xlarge)';

/**
 * Used to apply space between elements within cards or list rows.
 *
 * Reference value in default theme: `40px`
 */
export const spaceBroadXxlarge = 'var(--cb-space-broad-xxlarge)';

/**
 * Used to apply space between elements within cards or list rows.
 *
 * Reference value in default theme: `48px`
 */
export const spaceBroadXxxlarge = 'var(--cb-space-broad-xxxlarge)';

/**
 * Used to apply space between elements like containers.
 *
 * Reference value in default theme: `56px`
 */
export const spaceWideMedium = 'var(--cb-space-wide-medium)';

/**
 * Used to apply space between elements like containers.
 *
 * Reference value in default theme: `64px`
 */
export const spaceWideLarge = 'var(--cb-space-wide-large)';

/**
 * Used to apply space between elements like containers.
 *
 * Reference value in default theme: `84px`
 */
export const spaceWideXlarge = 'var(--cb-space-wide-xlarge)';

/**
 * Used to apply space between elements like containers.
 *
 * Reference value in default theme: `108px`
 */
export const spaceWideXxlarge = 'var(--cb-space-wide-xxlarge)';

/**
 * Used to apply space between elements like containers.
 *
 * Reference value in default theme: `140px`
 */
export const spaceWideXxxlarge = 'var(--cb-space-wide-xxxlarge)';

/**
 * Used for elements with sharp corners, like sidebars and nav bars.
 *
 * Reference value in default theme: `0px`
 */
export const cornerRadiusNone = 'var(--cb-corner-radius-none)';

/**
 * Used for small elements, like checkboxes.
 *
 * Reference value in default theme: `4px`
 */
export const cornerRadiusSmall = 'var(--cb-corner-radius-small)';

/**
 * Default corner radius, used for small elements, like buttons and inputs.
 *
 * Reference value in default theme: `8px`
 */
export const cornerRadiusMedium = 'var(--cb-corner-radius-medium)';

/**
 * Used for containers with nested elements within, like cards and banners.
 *
 * Reference value in default theme: `12px`
 */
export const cornerRadiusLarge = 'var(--cb-corner-radius-large)';

/**
 * Used for large containers, like sheets and modals.
 *
 * Reference value in default theme: `16px`
 */
export const cornerRadiusXlarge = 'var(--cb-corner-radius-xlarge)';

/**
 * Used for elements with fully rounded corners, like avatars or icon buttons.
 *
 * Reference value in default theme: `9999px`
 */
export const cornerRadiusMax = 'var(--cb-corner-radius-max)';

/**
 * Used for focus indicators in interfaces with a playful look.
 *
 * Reference value in default theme: `3px`
 */
export const borderWidthThickLarge = 'var(--cb-border-width-thick-large)';

/**
 * Used for focus indicators in interfaces with a minimalistic look.
 *
 * Reference value in default theme: `2px`
 */
export const borderWidthThickMedium = 'var(--cb-border-width-thick-medium)';

/**
 * Default border width in interfaces with a playful look.
 *
 * Reference value in default theme: `2px`
 */
export const borderWidthRegularLarge = 'var(--cb-border-width-regular-large)';

/**
 * Default border width in interfaces with a minimalistic look.
 *
 * Reference value in default theme: `1px`
 */
export const borderWidthRegularMedium = 'var(--cb-border-width-regular-medium)';

/**
 * Used for decorative borders, like table cells.
 *
 * Reference value in default theme: `1px`
 */
export const borderWidthThin = 'var(--cb-border-width-thin)';
